import { types } from 'mobx-state-tree';

import OrderAlertTypes from '../../types/order/OrderAlert';
import OrderAlert from './OrderAlert';

const OrderAlerts = types
  .model('OrderAlerts', {
    alerts: types.maybeNull(types.array(OrderAlert)),
  })
  .views((self) => {
    return {
      get commonAlerts() {
        return self.getModuleAlerts(null);
      },
      getAlerts(module) {
        return self.alerts?.filter((alert) => alert.section === module) || [];
      },
      getModuleAlerts(module) {
        const alerts = self.getAlerts(module);

        return {
          errors:
            alerts?.filter(
              (alert) =>
                alert.type === OrderAlertTypes.DANGER && !alert.is_static
            ) || [],
          general: alerts?.filter((alert) => alert.is_static) || [],
        };
      },
    };
  });

export default OrderAlerts;
